module.exports = __webpack_public_path__ + "images/emoji/construction_worker.93032ecead10ac1b5fb9.png";